/** @format */

import { useEffect, useRef } from 'react';

import Slider, { CustomArrowProps } from 'react-slick';
import { Container, Next, Prev, TeamCard } from './ourteam.style';

//images
import { useLocation } from 'react-router-dom';
import { useLiveEditorHighLighter } from '../../../../context/liveEditorHighighlighter.context';
import LiveEdithTextHighLighter from '../../../../liveEditHighlighterstyles/liveEdithTextHighLighter.component';
import LiveEditImageHighLighter from '../../../../liveEditHighlighterstyles/liveEditImageHighLighter.component';
type OurTeamProp = {
  section: string;
  data?: {
    text: string;
    description: string;
    description2: string;
    image: string;
    img: string;
  }[];
};

export default function OurTeam({ data, section }: OurTeamProp) {
  const location = useLocation();
  const pathname = location.pathname;
  const { state } = useLiveEditorHighLighter();
  const SliderRef = useRef(null);

  useEffect(() => {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const changeSlider = () => {
      const SlideNumber = state.type.split('-');
      if (SlideNumber.length > 1) {
        if (SliderRef.current) {
          SliderRef?.current?.slickGoTo(Number(SlideNumber[1]));
        }
      }
    };
    changeSlider();
  }, [state.type]);
  const CustomArrowsPrev = (props: CustomArrowProps) => {
    const { onClick } = props;
    return (
      <Prev onClick={onClick}>
        <svg
          width="50"
          height="50"
          viewBox="0 0 50 50"
          fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <path
            d="M25.1367 0.5C27.3789 0.5 29.5299 0.791667 31.5898 1.375C33.6497 1.95833 35.5911 2.77865 37.4141 3.83594C39.237 4.89323 40.8776 6.16016 42.3359 7.63672C43.7943 9.11328 45.0703 10.763 46.1641 12.5859C47.2578 14.4089 48.0781 16.3411 48.625 18.3828C49.1719 20.4245 49.4635 22.5846 49.5 24.8633C49.5 27.1055 49.2083 29.2565 48.625 31.3164C48.0417 33.3763 47.2214 35.3177 46.1641 37.1406C45.1068 38.9635 43.8398 40.6042 42.3633 42.0625C40.8867 43.5208 39.237 44.7969 37.4141 45.8906C35.5911 46.9844 33.6589 47.8047 31.6172 48.3516C29.5755 48.8984 27.4154 49.1901 25.1367 49.2266C22.8945 49.2266 20.7435 48.9349 18.6836 48.3516C16.6237 47.7682 14.6823 46.9479 12.8594 45.8906C11.0365 44.8333 9.39583 43.5664 7.9375 42.0898C6.47917 40.6133 5.20312 38.9635 4.10938 37.1406C3.01562 35.3177 2.19531 33.3854 1.64844 31.3438C1.10156 29.3021 0.809896 27.1419 0.773438 24.8633C0.773438 22.6211 1.0651 20.4701 1.64844 18.4102C2.23177 16.3503 3.05208 14.4089 4.10938 12.5859C5.16667 10.763 6.43359 9.1224 7.91016 7.66406C9.38672 6.20573 11.0365 4.92969 12.8594 3.83594C14.6823 2.74219 16.6146 1.92188 18.6562 1.375C20.6979 0.828125 22.8581 0.536458 25.1367 0.5ZM25.1367 45.7266C27.0508 45.7266 28.8919 45.4805 30.6602 44.9883C32.4284 44.4961 34.0964 43.7943 35.6641 42.8828C37.2318 41.9714 38.6354 40.8867 39.875 39.6289C41.1146 38.3711 42.1992 36.9583 43.1289 35.3906C44.0586 33.8229 44.7604 32.1641 45.2344 30.4141C45.7083 28.6641 45.9635 26.8138 46 24.8633C46 22.9492 45.7539 21.1081 45.2617 19.3398C44.7695 17.5716 44.0677 15.9128 43.1562 14.3633C42.2448 12.8138 41.151 11.401 39.875 10.125C38.599 8.84896 37.1953 7.76432 35.6641 6.87109C34.1328 5.97786 32.474 5.27604 30.6875 4.76562C28.901 4.25521 27.0508 4 25.1367 4C23.2227 4 21.3815 4.24609 19.6133 4.73828C17.8451 5.23047 16.1771 5.93229 14.6094 6.84375C13.0417 7.75521 11.638 8.83984 10.3984 10.0977C9.15885 11.3555 8.07422 12.7682 7.14453 14.3359C6.21484 15.9036 5.51302 17.5625 5.03906 19.3125C4.5651 21.0625 4.3099 22.9128 4.27344 24.8633C4.27344 26.7773 4.51953 28.6185 5.01172 30.3867C5.50391 32.1549 6.20573 33.8229 7.11719 35.3906C8.02865 36.9583 9.11328 38.362 10.3711 39.6016C11.6289 40.8411 13.0417 41.9258 14.6094 42.8555C16.1771 43.7852 17.8359 44.487 19.5859 44.9609C21.3359 45.4349 23.1862 45.6901 25.1367 45.7266ZM30.6055 14.8555L20.4883 25L30.6055 35.1445L28.1445 37.6055L15.5117 25L28.1445 12.3945L30.6055 14.8555Z"
            fill="white"
          />
        </svg>
      </Prev>
    );
  };
  const CustomArrowsNext = (props: CustomArrowProps) => {
    const { onClick } = props;
    return (
      <Next onClick={onClick}>
        <svg
          width="50"
          height="50"
          viewBox="0 0 50 50"
          fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <path
            d="M25.1367 49.2266C22.8945 49.2266 20.7435 48.9349 18.6836 48.3516C16.6237 47.7682 14.6823 46.9479 12.8594 45.8906C11.0365 44.8333 9.39583 43.5664 7.9375 42.0898C6.47917 40.6133 5.20312 38.9635 4.10938 37.1406C3.01562 35.3177 2.19531 33.3854 1.64844 31.3437C1.10156 29.3021 0.809895 27.1419 0.773438 24.8633C0.773438 22.6211 1.06511 20.4701 1.64844 18.4102C2.23177 16.3503 3.05208 14.4089 4.10938 12.5859C5.16667 10.763 6.43359 9.12239 7.91016 7.66406C9.38672 6.20573 11.0365 4.92969 12.8594 3.83594C14.6823 2.74219 16.6146 1.92187 18.6563 1.375C20.6979 0.828125 22.8581 0.536457 25.1367 0.5C27.3789 0.5 29.5299 0.791668 31.5898 1.375C33.6497 1.95833 35.5911 2.77864 37.4141 3.83594C39.237 4.89323 40.8776 6.16016 42.3359 7.63672C43.7943 9.11328 45.0703 10.763 46.1641 12.5859C47.2578 14.4089 48.0781 16.3411 48.625 18.3828C49.1719 20.4245 49.4635 22.5846 49.5 24.8633C49.5 27.1055 49.2083 29.2565 48.625 31.3164C48.0417 33.3763 47.2214 35.3177 46.1641 37.1406C45.1068 38.9635 43.8398 40.6042 42.3633 42.0625C40.8867 43.5208 39.237 44.7969 37.4141 45.8906C35.5911 46.9844 33.6589 47.8047 31.6172 48.3516C29.5755 48.8984 27.4154 49.1901 25.1367 49.2266ZM25.1367 4C23.2227 4 21.3815 4.24609 19.6133 4.73828C17.8451 5.23047 16.1771 5.93229 14.6094 6.84375C13.0417 7.75521 11.638 8.83984 10.3984 10.0977C9.15886 11.3555 8.07422 12.7682 7.14453 14.3359C6.21484 15.9036 5.51302 17.5625 5.03906 19.3125C4.56511 21.0625 4.30989 22.9128 4.27344 24.8633C4.27344 26.7773 4.51953 28.6185 5.01172 30.3867C5.50391 32.1549 6.20573 33.8138 7.11719 35.3633C8.02864 36.9128 9.12239 38.3255 10.3984 39.6016C11.6745 40.8776 13.0781 41.9622 14.6094 42.8555C16.1406 43.7487 17.7995 44.4505 19.5859 44.9609C21.3724 45.4714 23.2227 45.7266 25.1367 45.7266C27.0508 45.7266 28.8919 45.4805 30.6602 44.9883C32.4284 44.4961 34.0964 43.7943 35.6641 42.8828C37.2318 41.9714 38.6354 40.8867 39.875 39.6289C41.1146 38.3711 42.1992 36.9583 43.1289 35.3906C44.0586 33.8229 44.7604 32.1641 45.2344 30.4141C45.7083 28.6641 45.9635 26.8138 46 24.8633C46 22.9492 45.7539 21.1081 45.2617 19.3398C44.7695 17.5716 44.0677 15.9036 43.1563 14.3359C42.2448 12.7682 41.1602 11.3646 39.9023 10.125C38.6445 8.88542 37.2318 7.80078 35.6641 6.87109C34.0964 5.94141 32.4375 5.23958 30.6875 4.76562C28.9375 4.29167 27.0872 4.03646 25.1367 4ZM19.668 34.8711L29.7852 24.7266L19.668 14.582L22.1289 12.1211L34.7617 24.7266L22.1289 37.332L19.668 34.8711Z"
            fill="white"
          />
        </svg>
      </Next>
    );
  };
  const TeamSettings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: Math.min(3, data?.length),
    slidesToScroll: 1,
    arrows: true,
    autoplay: pathname.includes('designer') ? false : true,
    cssEase: 'linear',
    nextArrow: <CustomArrowsNext />,
    prevArrow: <CustomArrowsPrev />,
    responsive: [
      {
        breakpoint: 1297,
        settings: {
          slidesToShow: Math.min(2, data?.length),
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 891,
        settings: {
          slidesToShow: Math.min(1, data?.length),
          slidesToScroll: 1,
        },
      },
    ],
  };
  return (
    <Container id={section}>
      {data?.map((data, index) => (
        <div
          className="team_card_wrapper"
          key={index}>
          <TeamCard>
            <div className="team_image_wrapper">
              <LiveEditImageHighLighter
                section={section}
                type={`image-${index}`}>
                <img
                  src={`/public/${data.image || data.img}`}
                  alt="TeamImage"
                />
              </LiveEditImageHighLighter>
            </div>
            <h4>
              <LiveEdithTextHighLighter
                section={section}
                type={`text-${index}`}>
                {data.text}
              </LiveEdithTextHighLighter>
            </h4>
            <p>
              <LiveEdithTextHighLighter
                section={section}
                type={`description-${index}`}>
                {data.description}
              </LiveEdithTextHighLighter>
            </p>
            <div className='teamDis mb-2'>
              <input type="checkbox" id={`toggle2-${index}`} className="d-none" />
              <p className="text-content">
                <LiveEdithTextHighLighter
                  section={section}
                  type={`description2-${index}`}>
                  {data.description2}
                </LiveEdithTextHighLighter>
              </p>
              <label htmlFor={`toggle2-${index}`} className="toggle-link">
                <span className="show-more">More</span>
                <span className="show-less">Less</span>
              </label>
            </div>
          </TeamCard>
        </div>
      ))}

    </Container>
  );
}
